export default function Loading() {
  return (
    <div className="flex w-full h-full items-center justify-center text-center">
      Загрузка карты...
    </div>
  );
}
